import { Injectable } from '@angular/core';
const TOKEN_KEY = 'auth-token';
@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}
  public savedata(key: string, value: string) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  public fetchdata(key: string) {
    return localStorage.getItem(key);
  }
  public deletedata(key: string) {
    localStorage.removeItem(key);
  }
  public cleardata() {
    localStorage.clear();
  }

  /**
   * Save Token in localStorage creating key and storing value
   *
   * @param token token to store
   *
   */
  public saveToken(token: string) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
    // Keep SPFT legacy key in sync for shared SSO across micro-frontends.
    localStorage.setItem('accessToken', token);
  }
  /* To get the token value through key */
  public getToken(): any {
    return localStorage.getItem(TOKEN_KEY);
  }
}
